import React, { useState, useEffect, useRef } from "react";
import { chatGptList } from "./chatBotList";
import Typed from "typed.js";
import { Tag } from "../../type";
import { useNavigate } from "react-router-dom";
import { getGPTStationsApi, getStationApi } from "../../Api/baseApi";
import "./chatBot.css";

const Typing = ({ text, onCom }: { text: string; onCom?: any }) => {
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [text],
      typeSpeed: process.env.NODE_ENV !== "production" ? 1 : 30,
      showCursor: false,
      onComplete: () => {
        onCom && onCom();
      },
    });

    return () => {
      typed.destroy();
    };
  }, [onCom, text]);

  return (
    <div className="min-w-full mb-2">
      <span
        className="px-4 py-2 inline-block rounded-lg rounded-tl-none leading-6 text-white break-keep bg-[#e10555] whitespace-pre-wrap"
        ref={el}
      ></span>
    </div>
  );
};
const Reaction = ({ tag, onCom }: { tag: Tag; onCom: any }) => {
  const [ready, setready] = useState(true);
  const ment = { ...tag }.ment.sort(() => Math.random() - 0.5)[0];
  return (
    <div className="h-80">
      {!ready && (
        <div className="absolute left-0 z-10 flex items-start gap-4">
          <Profile children={[<Typing onCom={onCom} text={ment} />]} isAi />
        </div>
      )}
      <img
        className="absolute top-0 left-0 object-cover w-full h-80"
        onLoad={() => setready(false)}
        src={tag.bg}
        alt=""
      />
      <img
        className="absolute top-0 left-0 object-cover w-full h-80"
        alt=""
        src="/imgs/chatBot/black.png"
      />
    </div>
  );
};
const MyText = ({ text }: { text: string }) => {
  return (
    <div className="flex justify-end mb-6">
      <span className="px-2 py-1 inline-block rounded-lg rounded-tr-none leading-6 break-keep bg-[#8d39f0] text-white whitespace-pre-wrap">
        {text}
      </span>
    </div>
  );
};
const scrollToEnd = () => {
  window.scrollTo(0, document.body.scrollHeight);
};
const Profile = ({
  children,
  isAi,
}: {
  children: JSX.Element[];
  isAi: boolean;
}) => {
  return (
    <>
      {isAi && (
        <img
          className="w-12 rounded-full"
          alt="제이든"
          src="/imgs/chatBot/chatBot.png"
        />
      )}
      <div style={{ width: "100%" }}>
        {isAi && <div className="mb-2 text-white">제이든</div>}
        {children}
      </div>
    </>
  );
};
export const ChatBot = () => {
  const navigate = useNavigate();

  const TEXT = `안녕하세요. 리스너님!`;
  const TEXT2 = `태그선택을 통해 리스너님에게 딱 맞는 스테이션을 추천해드릴게요 😊`;

  const [chatList, setChatList] = useState<JSX.Element[][]>([]);
  const [tagList, setTagList] = useState<Tag[]>([]);
  const procces = useRef(-1);

  const TagList = ({
    tagList,
    onClick,
    none,
  }: {
    tagList: Tag[];
    onClick: any;
    none?: Tag;
  }) => {
    const [list, setList] = useState(tagList.sort(() => Math.random() - 0.5));

    const mix = () => {
      setList((old) => {
        const fuck = [...old];
        fuck.sort(() => Math.random() - 0.5);
        return fuck;
      });
    };
    const onClickNo = () => {
      if (!none) return;

      let idx = 0;
      chatGptList.forEach((chat, chatIdx) => {
        if (chat.none.ment[0] === none.ment[0]) {
          idx = chatIdx;
        }
      });
      if (idx !== procces.current) return;
      procces.current = procces.current + 1;
      setTagList((old) => old.concat(none));
      setChatList((old) => old.concat([[<MyText text="없어요🤔" />]]));
      setChatList((old) =>
        old.concat([
          [
            <Typing
              text={none.ment.sort(() => Math.random() - 0.5)[0]}
              onCom={() => {
                add(
                  <img
                    className="w-80"
                    alt="제이든"
                    src="/imgs/chatBot/noChoice.png"
                  />,
                );
                setTimeout(() => {
                  doQuestion();
                }, 1000);
              }}
            />,
          ],
        ]),
      );
    };
    return (
      <div className="mt-4">
        {none && (
          <button
            onClick={onClickNo}
            className="bg-white text-black px-5 py-2 mr-2 mb-8 rounded-[60px]"
          >
            <span style={{ color: "black" }} role="img" aria-label="없어요">
              없어요🤔
            </span>
          </button>
        )}
        {list.slice(0, 6).map((el, idx) => (
          <button
            key={idx}
            onClick={() => onClick(el)}
            className="bg-white text-black px-5 py-2 mr-2 mb-8 rounded-[60px]"
          >
            {el.tag}
          </button>
        ))}
        {list.length !== 1 && (
          <button className="text-sm" onClick={mix}>
            <div className="flex items-center justify-center text-white">
              새로고침
              <img
                className="w-4 ml-1"
                alt="새로고침"
                src="/imgs/chatBot/refresh.png"
              />
            </div>
          </button>
        )}
      </div>
    );
  };

  const add = (el: JSX.Element) => {
    setChatList((old) => {
      const _old = [...old];
      const fuck = [..._old[_old.length - 1]];
      fuck.push(el);
      _old[_old.length - 1] = fuck;
      return _old;
    });
  };
  const addTyping = (text: string, onCom?: any) => {
    add(<Typing onCom={onCom} text={text} />);
  };
  const addTagList = (tagList: Tag[], onClick: any, none?: Tag) => {
    add(<TagList onClick={onClick} tagList={tagList} none={none} />);
  };
  const addReaction = (tag: Tag, onCom: any) => {
    setChatList((old) => old.concat([[<Reaction tag={tag} onCom={onCom} />]]));
  };
  const start = () => {
    if (procces.current !== -1) return;
    procces.current = procces.current + 1;
    setChatList((old) => old.concat([[<MyText text="시작하기" />]]));
    setChatList((old) =>
      old.concat([
        [
          <Typing
            onCom={() => {
              addTagList(
                chatGptList[0].tagList,
                choiceTag,
                chatGptList[0].none,
              );
            }}
            text={chatGptList[0].question.sort(() => Math.random() - 0.5)[0]}
          />,
        ],
      ]),
    );
  };
  const findTag = (_tag: Tag) => {
    let idx = 0;
    chatGptList.forEach((chat, chatIdx) => {
      chat.tagList.forEach((tag, tagIdx) => {
        if (_tag === tag) idx = chatIdx;
      });
    });

    return idx;
  };
  const doQuestion = () => {
    if (procces.current === 4) return;
    setChatList((old) => old.concat([[<></>]]));
    setChatList((old) =>
      old.concat([
        [
          <Typing
            text={
              chatGptList[procces.current].question.sort(
                () => Math.random() - 0.5,
              )[0]
            }
            onCom={() => {
              addTagList(
                chatGptList[procces.current].tagList,
                choiceTag,
                chatGptList[procces.current].none,
              );
            }}
          />,
        ],
      ]),
    );
  };

  const choiceTag = (tag: Tag) => {
    const idx = findTag(tag);

    if (idx !== procces.current) return;
    procces.current = procces.current + 1;

    setTagList((old) => old.concat(tag));
    setChatList((old) => old.concat([[<MyText text={tag.tag} />]]));
    addReaction(tag, () => {
      doQuestion();
    });
  };
  const first = () => {
    setChatList((old) =>
      old.concat([
        [
          <Typing
            text={TEXT}
            onCom={() => {
              addTyping(TEXT2, () => {
                add(
                  <img
                    className="w-80"
                    alt="제이든"
                    src="/imgs/chatBot/jdon.png"
                  />,
                );
                setTimeout(() => {
                  addTagList([{ tag: "시작하기" } as Tag], start);
                }, 300);
              });
            }}
          />,
        ],
      ]),
    );
  };
  const getStations = async (body: any) => {
    // const {
    //   data: { data },
    // } = await getGPTStationsApi(body);
    const { data } = await getStationApi(2, body.genre);
    console.log(data);
    setTimeout(() => {
      navigate("/musiclist", {
        state: { musicList: data, stationIdx: data.indjStationId },
      });
    }, 2000);
  };

  useEffect(() => {
    first();
    chatGptList.sort(() => Math.random() - 0.5);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tagList.length === 4) {
      const body: { [idx: string]: number } = {};
      chatGptList.forEach((tag, idx) => {
        body[tag.key] = tagList[idx].idx;
      });

      getStations(body);
    }
  }, [tagList]);
  useEffect(() => {
    scrollToEnd();
  }, [chatList]);

  return (
    <div className="bg-[#181818] min-h-[100vh] pb-10">
      <div className="max-w-5xl pt-8 mx-auto">
        {chatList.map((el, id) => {
          return (
            <div
              key={id}
              className="relative flex items-start justify-start gap-4"
            >
              {
                <>
                  <Profile
                    children={el.map((chat, idx) => {
                      return (
                        <div
                          key={`${id}-${idx}`}
                          className={`chat_node ${id % 2 === 1 && "my"}`}
                        >
                          {chat}
                        </div>
                      );
                    })}
                    isAi={id % 2 !== 1}
                  />
                </>
              }
            </div>
          );
        })}
        {procces.current === 4 && (
          <div className="result">
            <div className="rounded-[47px] p-[2px] bg-[rgba(255,5,85,0.6)] w-72 mx-auto">
              <div className="flex items-center justify-center gap-1 my-1 text-white">
                <span>분석중 입니다</span>
                <span className="delay-100 anal_dot"></span>
                <span className="delay-200 anal_dot"></span>
                <span className="delay-300 anal_dot"></span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
